import { useSelector } from 'react-redux';
import {
  getCurrentUserInfo,
  selectCurrentUserPermissions,
  getSelectedUserInfo,
} from '_helpers/reduxSelector';
import { useQuery } from 'react-query';
import { profileService } from '_services/profile.service';
import IfcaContract from './IfcaContract';
import NationalCrewContract from './NationalCrewContract';
import ViprContract from './ViprContract';
import GeneralQualification from './GeneralQualification';
import ManageQualifications from './ManageQualifications';

export default function UserQualifications() {
  const selectedUserInfo = useSelector(getSelectedUserInfo);
  const authUser = useSelector(getCurrentUserInfo);
  const currentUserPermissions = useSelector(selectCurrentUserPermissions);

  const { data: profileData, refetch: refetchUser } = useQuery(
    ['userData', selectedUserInfo?.hash], // Unique key including userHash to prevent conflicts
    () => profileService.getUser(selectedUserInfo?.hash), // Pass function reference, not the result
    {
      enabled: !!selectedUserInfo?.hash, // Ensure query only runs when userHash is available
      onSuccess: (data) => {
        // Set state after successful fetch
      },
    },
  );

  const { data: dropdownData } = useQuery(
    'dropdownData',
    profileService.fetchDropdownData,
  );

  return profileData && dropdownData ? (
    <div className='content_div settings'>
      <GeneralQualification
        profileData={profileData}
        refetchUser={refetchUser}
        currentUserPermissions={currentUserPermissions}
        authUser={authUser}
        dropdownData={dropdownData}
      />

      <ManageQualifications
        profileData={profileData}
        currentUserPermissions={currentUserPermissions}
        refetchUser={refetchUser}
        qualificationsList={dropdownData.Qualification}
      />

      <NationalCrewContract
        profileData={profileData}
        refetchUser={refetchUser}
        currentUserPermissions={currentUserPermissions}
        authUser={authUser}
      />

      <ViprContract
        profileData={profileData}
        refetchUser={refetchUser}
        currentUserPermissions={currentUserPermissions}
        authUser={authUser}
      />

      <IfcaContract
        profileData={profileData}
        refetchUser={refetchUser}
        currentUserPermissions={currentUserPermissions}
        authUser={authUser}
        dropdownData={dropdownData}
      />
    </div>
  ) : (
    <></>
  );
}
